import React from "react";
import { Link } from "react-router-dom";

export const customerPolicyLinks = [
  { label: "Shipping & delivery", to: "/shipping" },
  { label: "Returns & refunds", to: "/returns" },
  { label: "Orders & cancellation", to: "/orders" },
  { label: "Payments & security", to: "/payments" },
  { label: "Product care & warranty", to: "/warranty" },
  { label: "Promotions & gift cards", to: "/promotions" },
  { label: "Complaints", to: "/complaints" },
  { label: "FAQs", to: "/faqs" },
];

export const legalPolicyLinks = [
  { label: "Privacy notice", to: "/privacy" },
  { label: "Privacy choices", to: "/privacy-choices" },
  { label: "Cookie policy", to: "/cookies" },
  { label: "Terms of sale & use", to: "/terms" },
  { label: "Legal notice", to: "/legal-notice" },
  { label: "Intellectual property", to: "/intellectual-property" },
  { label: "Accessibility", to: "/accessibility" },
  { label: "Disclaimer", to: "/disclaimer" },
];

function PolicyLinks({ activePath, links }) {
  return links.map((link) => (
    <Link
      className={activePath === link.to ? "is-active" : undefined}
      aria-current={activePath === link.to ? "page" : undefined}
      key={link.to}
      to={link.to}
    >
      {link.label}
    </Link>
  ));
}

export default function PolicySidebar({ activePath, tableOfContents = [] }) {
  return (
    <aside className="policy-sidebar">
      <nav aria-label="Customer policies">
        <p>Customer care</p>
        <PolicyLinks activePath={activePath} links={customerPolicyLinks} />
      </nav>
      <nav aria-label="Legal policies">
        <p>Legal &amp; information</p>
        <PolicyLinks activePath={activePath} links={legalPolicyLinks} />
      </nav>
      {tableOfContents.length > 0 && (
        <nav className="policy-toc" aria-label="On this page">
          <p>On this page</p>
          {tableOfContents.map((item) => (
            <a href={`#${item.id}`} key={item.id}>
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </aside>
  );
}
